const { signal } = require("@preact/signals");

export const farmerSignal = signal(null);
